import axios from "axios";

let token;

export default {
  init: function (csrfToken) {
    token = csrfToken;
  },
  getComments: function (blockId, sortering) {
    const getCommentsUrl = 
      "/ubnoy/umucmsapi/comments/block" + 
      `?blockId=${blockId}` +
      `&sortering=${sortering}`;
    var response = axios.get(
      getCommentsUrl
    );

    return response;
  },
  addComment: function (comment) {
    axios.defaults.headers.post["Requestverificationtoken"] = token;
    const addCommentUrl = "/ubnoy/umucmsapi/comments/comment";
    var response = axios.post(
      addCommentUrl, comment
    );

    return response;
  },
  editComment: function (comment) {
    axios.defaults.headers.put["Requestverificationtoken"] = token;
    const editCommentUrl = "/ubnoy/umucmsapi/comments/comment";
    var response = axios.put(
      editCommentUrl, comment
    );

    return response;
  },
  removeComment: function (commentId, isAdmin) {
    axios.defaults.headers.delete["Requestverificationtoken"] = token;
    const removeCommentUrl = 
      "/ubnoy/umucmsapi/comments/comment" + 
      `/?commentId=${commentId}` +
      `&isAdmin=${isAdmin}`;
    var response = axios.delete(
      removeCommentUrl
    );

    return response;
  },
};